"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.InputWrapper = exports.InputStyled = exports.InputFieldWrapper = exports.HelpTextWrapper = exports.HelpText = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = require("../style/colors");
var _fonts = require("../style/fonts");
var _Text = _interopRequireDefault(require("../Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const inputPadding = /*#__PURE__*/(0, _styledComponents.css)(["padding:", ";"], _ref => {
  let {
    size
  } = _ref;
  switch (size) {
    case 'small':
      return '5px 8px 4px 8px';
    case 'tall':
      return '13px 16px 12px 16px';
    default:
      return '9px 8px 8px 8px';
  }
});
const inputPrefix = /*#__PURE__*/(0, _styledComponents.css)(["&:before{content:'", "';position:absolute;top:0;left:0;color:", ";width:", ";z-index:10;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";margin:8px 0;", " border:1px solid transparent;user-select:none;pointer-events:none;}"], _ref2 => {
  let {
    prefix
  } = _ref2;
  return prefix.text;
}, _colors.gray, _ref3 => {
  let {
    prefix
  } = _ref3;
  return prefix.paddingLeft;
}, _fonts.fontFamily, _fonts.fontSize, _fonts.fontWeight, _fonts.lineHeight, inputPadding);
const InputWrapper = exports.InputWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__InputWrapper",
  componentId: "bufferapp-ui__sc-fu8s8n-0"
})(["width:100%;"]);
const InputFieldWrapper = exports.InputFieldWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__InputFieldWrapper",
  componentId: "bufferapp-ui__sc-fu8s8n-1"
})(["position:relative;", ";"], _ref4 => {
  let {
    prefix
  } = _ref4;
  return prefix ? inputPrefix : '';
});
const InputStyled = exports.InputStyled = /*#__PURE__*/_styledComponents.default.input.withConfig({
  displayName: "style__InputStyled",
  componentId: "bufferapp-ui__sc-fu8s8n-2"
})(["box-sizing:border-box;margin:8px 0px;background:", ";border-radius:4px;border:1px solid ", ";box-shadow:2px 2px 0 2px transparent;transition-property:border-width,border-color,box-shadow;transition-duration:0.1s;transition-timing-function:ease-in;color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";", " width:100%;", " ", " &::placeholder{color:", ";}&:focus{border:1px solid ", ";box-shadow:0px 0px 0px 3px ", ";outline:none;transition-property:border-width,border-color,box-shadow;transition-duration:0.1s;transition-timing-function:ease-in;}&:disabled{background:", ";border:1px solid ", ";color:", ";cursor:not-allowed;&::placeholder{color:", ";}}"], _ref5 => {
  let {
    hasError
  } = _ref5;
  return hasError ? _colors.redLightest : _colors.white;
}, _ref6 => {
  let {
    hasError
  } = _ref6;
  return hasError ? _colors.redDark : _colors.gray;
}, _ref7 => {
  let {
    hasError
  } = _ref7;
  return hasError ? _colors.redDark : _colors.grayDarker;
}, _fonts.fontFamily, _fonts.fontSize, _fonts.fontWeight, _fonts.lineHeight, inputPadding, _ref8 => {
  let {
    prefix
  } = _ref8;
  return prefix ? `padding-left: ${prefix.paddingLeft};` : '';
}, _ref9 => {
  let {
    icon
  } = _ref9;
  return icon ? `padding-left: 32px;` : '';
}, _colors.grayDark, _ref10 => {
  let {
    hasError
  } = _ref10;
  return hasError ? _colors.redDark : _colors.blue;
}, _ref11 => {
  let {
    hasError
  } = _ref11;
  return hasError ? _colors.redLighter : _colors.blueLighter;
}, _colors.grayLight, _colors.grayLight, _colors.grayDark, _colors.grayDark);
const HelpTextWrapper = exports.HelpTextWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__HelpTextWrapper",
  componentId: "bufferapp-ui__sc-fu8s8n-3"
})(["display:flex;display:row;align-items:center;justify-content:flex-start;color:", ";"], _colors.redDark);
const HelpText = exports.HelpText = /*#__PURE__*/(0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "style__HelpText",
  componentId: "bufferapp-ui__sc-fu8s8n-4"
})(["margin-left:", ";"], props => props.hasError ? '8px' : '0px');
const StyledIcon = exports.StyledIcon = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__StyledIcon",
  componentId: "bufferapp-ui__sc-fu8s8n-5"
})(["position:absolute;left:8px;top:50%;transform:translate(0,-50%);display:flex;"]);